// extracted by mini-css-extract-plugin
export var crumb = "Breadcrumbs-module--crumb--a1717";
export var lastCrumb = "Breadcrumbs-module--lastCrumb--6c4ff";
export var root = "Breadcrumbs-module--root--63f5e";
export var spacer = "Breadcrumbs-module--spacer--741e9";